import React from 'react';

const FormSelect = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  options = [],
  placeholder,
  error,
  required = false,
  disabled = false,
  hint,
}) => {
  const fieldId = id || name;
  const errorId = error ? `${fieldId}-error` : undefined;
  const hintId = hint ? `${fieldId}-hint` : undefined;
  const describedBy = [errorId, hintId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={`tf-field${error ? ' tf-field--invalid' : ''}`}>
      {label && (
        <label htmlFor={fieldId} className="tf-field__label">
          {label}{required && <span aria-hidden="true" className="tf-field__required"> *</span>}
        </label>
      )}
      <select
        id={fieldId}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
        aria-invalid={!!error}
        aria-required={required || undefined}
        aria-describedby={describedBy}
        className="tf-field__input tf-field__input--select"
      >
        {placeholder && (
          <option value="" disabled={required}>{placeholder}</option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {hint && !error && (
        <span id={hintId} className="tf-field__hint">{hint}</span>
      )}
      {error && (
        <span id={errorId} className="tf-field__error" role="alert">{error}</span>
      )}
    </div>
  );
};

export default FormSelect;
